var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('div',{staticClass:"w-100 py-3"},[_c('hr')])])}
var staticRenderFns = []

export { render, staticRenderFns }